import { mapGetters, mapActions } from 'vuex'

import { metaInfoBuilder, jsonLdBuilder } from '../utilities'
import { PAGES, BLOCKS } from '../content-types'

const type = PAGES.PLP

export const ProductListingPageComponent = {
  name: 'PageComponent',
  data() {
    return {
      page: null
    }
  },
  computed: {
    ...mapGetters('prismic', ['getPage', 'getBlock', 'getAlternateLanguages']),
    components() {
      const content = this.page ? this.page.content : []
      return content
    },
    plpGridEditorialComponents() {
      const content = this.page ? this.page.content : []
      const plpGridEditorialComponents = content.filter(
        component => component.component === BLOCKS.PLP_EDITORIAL_BLOCK
      )
      return plpGridEditorialComponents
        ? plpGridEditorialComponents.map(block => ({...block.items[0]}))
        : []
    },
    plpStrapsEditorialComponents() {
      const content = this.page ? this.page.content : []
      const plpStrapsEditorialComponents = content.filter(
        component => component.component === BLOCKS.PLP_STRAPS_EDITORIAL_BLOCK
      )
      return plpStrapsEditorialComponents
        ? plpStrapsEditorialComponents.map(block => ({...block.items[0]}))
        : []
    },
    productJsonLd() {
      return this.getJsonLd()
    }
  },
  methods: {
    ...mapActions('prismic', ['setPage', 'setBlock']),
    getJsonLd() {
      const page = this.getPage({ type, uid: this.$route.params.slug })
      return page ? jsonLdBuilder(page, this.$route) : {}
    },
    async setContent(): Promise<void> {
      const prefetchedPage = this.getPage({
        uid: this.$route.params.slug,
        type
      })
      let page

      if (prefetchedPage) {
        page = prefetchedPage
      } else {
        const pageRequest = this.setPage({ type, uid: this.$route.params.slug })

        await Promise.all([pageRequest])
        page = this.getPage({ uid: this.$route.params.slug, type })
      }
      this.page = page
    }
  },
  async serverPrefetch(): Promise<void> {
    await this.setContent()
  },
  async created(): Promise<void> {
    await this.setContent()
  },
  metaInfo() {
    const page = this.page
    return page
      ? metaInfoBuilder(
          page,
          this.$route,
          this.getAlternateLanguages({ type, uid: this.$route.params.uid })
        )
      : {}
  }
}
